
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.793 10.109l-.821-.69v11.569s0 0 0 0c0 .698-.196 1.18-.535 1.513-.34.333-.838.53-1.566.53h-15c-.728 0-1.223-.197-1.558-.529-.336-.333-.532-.815-.532-1.514V9.473l-.821.689L1.6 11.3l-.01.009-.01.01a1.233 1.233 0 01-.28.195.499.499 0 01-.234.056c-.22 0-.339-.062-.418-.145a.464.464 0 01-.148-.34c0-.153.056-.291.23-.434h0l.002-.002L12.275.957h0C12.652.638 13.03.5 13.425.5c.394 0 .767.14 1.133.453h0l.004.004 5.59 4.693.82.69V5.266l.002-2.138v0c0-.141.038-.197.072-.23.045-.042.113-.079.248-.079h1.371c.136 0 .198.037.237.075.032.032.072.089.072.234 0 0 0 0 0 0l-.001 4.657v.233l.178.15 2.952 2.478h.001c.143.123.21.263.21.462 0 .17-.051.257-.128.322a.606.606 0 01-.415.14.49.49 0 01-.236-.054 1.93 1.93 0 01-.324-.218l-.002-.001-1.415-1.19zm-7.688 11.407v.5h4.274c.439 0 .854-.12 1.16-.432.304-.31.418-.73.418-1.17V8.565l-.178-.15-7.59-6.38a1.134 1.134 0 00-.783-.303h-.001c-.287.008-.539.121-.746.302L4.964 8.483l-.18.15v.233l.001 11.548c0 .444.117.863.428 1.174.306.307.715.428 1.15.428h4.355V14.18v0c0-.146.041-.216.09-.264.053-.05.13-.092.278-.092h4.676c.15 0 .216.041.257.084.045.046.087.119.087.272 0 0 0 0 0 0l-.001 7.336z","fill":"#748190","stroke":"#748190"}})])
          )
        }
      }
    